import { Query } from '../containers/HealthcareUsageReport/types/CohortQuery'
import { SharedItem } from "./Sharing";

export interface Project {
    id: number
    active: boolean | true
    createdOn?: number
    updatedOn?: number
    title: string
    description: string
    loginId: string
    queries: Query[]
    example: boolean
}

export interface SharedProject extends Project {
    sharedItem: SharedItem
}

export function isSharedProject(project: Project): project is SharedProject {
    return "sharedItem" in project && project['sharedItem'] !== null;
}

export interface Tracker {
    id: string
    left:string | null
    result: string
    right: string | null
    description: string
    trackLevel: string
    timeBetweenEvents: TimeBetweenEvents
}
export interface TimeBetweenEvents {
    days: number[]
    weeks: number[]
    months: number[]
}